<template>
    <div id="parametre-list" v-if="parametres.length!=0">
        <ParametreItem v-for="parametre in parametres" v-bind:key="parametre.idParametre" v-bind:parametre="parametre">
        </ParametreItem>
    </div>
</template>

<script>

import ParametreItem from "@/components/Requete/Parametre.vue"
export default {
    name:"ParametreList",
    components: {ParametreItem},
    props:{
        parametres:{
            required:true,
            type:Array
        },
    },
}
</script>